import { useEffect, useState } from 'react';
import { track } from '../engine/track.ts';
import { CREAM, GRAD, INK, LINE, MUTED, PAPER } from '../ui/theme.ts';

/**
 * Shown only when consent is required (settings.features.consentBanner, or the
 * lang is in settings.euLangs). Until it is answered GA4 stays in consent-mode
 * denied and the pixel is not loaded; first-party events still reach the Worker.
 */
export function ConsentBanner({ text }: { text?: { body?: string; decline?: string; accept?: string } }) {
  const [answered, setAnswered] = useState(false);
  const [, rerender] = useState(0);
  useEffect(() => track.subscribe(() => rerender((n) => n + 1)), []);
  const open = !answered && track.decided && track.consentRequired() && !track.hasConsent;
  if (!open) return null;

  const close = (granted: boolean) => {
    setAnswered(true);
    track.setConsent(granted);
  };

  return (
    <div
      role="dialog"
      aria-label="Cookies"
      style={{
        position: 'sticky',
        bottom: 0,
        margin: 12,
        padding: 14,
        borderRadius: 20,
        background: PAPER,
        border: `2px solid ${LINE}`,
        boxShadow: '0 14px 36px rgba(31,27,45,.16)',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        zIndex: 20,
      }}
    >
      <div style={{ fontSize: 13, fontWeight: 600, color: MUTED }}>
        {text?.body ?? 'We use cookies to measure how this quiz performs. Your answers work either way.'}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        <button type="button" onClick={() => close(false)} style={{ minHeight: 44, borderRadius: 999, border: `2px solid ${LINE}`, background: CREAM, color: INK, fontWeight: 800, cursor: 'pointer' }}>
          {text?.decline ?? 'Only necessary'}
        </button>
        <button type="button" onClick={() => close(true)} style={{ minHeight: 44, borderRadius: 999, border: 0, background: GRAD, color: '#fff', fontWeight: 800, cursor: 'pointer' }}>
          {text?.accept ?? 'Accept'}
        </button>
      </div>
    </div>
  );
}
